module.exports = __webpack_public_path__ + "img/1.a08fbf4a.png";